import type { FC } from "react";

import { Card, CardRowSimple, type GridCard, Tag, TagIntent } from "widgets";

import style from "../../core/cards/styles/Card.module.scss";

import type { BlastJob, BlastParams } from "../../../graphql.js";

export interface IJobBlastInputCardProps extends GridCard {
  job: BlastJob;
}

const JobBlastInputCard: FC<IJobBlastInputCardProps> = (props) => {
  const job: BlastJob = props.job;
  const blastParams: BlastParams = job.params.blast;

  return (
    <Card key="blast-input-card" title={"BLAST Input"}>
      <CardRowSimple label={"Method"}>
        <div className={style.tags_list}>
          <Tag label={blastParams.blastType.toUpperCase()} />
        </div>
      </CardRowSimple>
      {blastParams.targets?.length > 0 && (
        <CardRowSimple label={"Database"}>
          <div className={style.tags_list}>
            {blastParams.targets.map((target) => (
              <Tag
                label={`${target.name} (${target.sequenceType})`}
                intentColor={TagIntent.Secondary}
                key={`job-card-target=${target.id}`}
              />
            ))}
          </div>
        </CardRowSimple>
      )}
      <CardRowSimple label={"Number of queries"} value={job.resultCount} />
    </Card>
  );
};

export { JobBlastInputCard };
